<template>
  <div class="fankui-page">
    <!-- 未登录提示 -->
    <div class="not-login-tip" v-if="!isLogin">
      <img src="/static/image/img_none_sj.avif" class="empty-img" alt="">
      <p class="t1">登录后才能提交和查看反馈哦</p>
      <div class="btns">
        <div class="btn-login" @click="openLogin(1)">立即登录</div>
        <div class="btn-register" @click="openLogin(0)">去注册</div>
      </div>
    </div>

    <template v-else>
      <div class="fankui-tabs">
        <div class="fankui-tab" :class="{ active: activeFankuiTab === 0 }" @click="activeFankuiTab = 0">创建反馈</div>
        <div class="fankui-tab" :class="{ active: activeFankuiTab === 1 }" @click="activeFankuiTab = 1; loadMyList(true)">我的反馈</div>
      </div>

      <!-- ① 创建反馈 -->
      <div v-if="activeFankuiTab === 0" class="fankui-form">
        <div class="form-item">
          <div class="form-label">反馈分类<span class="required">*</span></div>
          <div class="form-select" @click="showCategoryPicker = !showCategoryPicker">
            <span :class="{ placeholder: !form.category_id }">{{ categoryName || '请选择分类' }}</span>
            <van-icon :name="showCategoryPicker ? 'arrow-up' : 'arrow-down'" />
          </div>
          <div class="type-dropdown" v-if="showCategoryPicker">
            <div
              class="type-option"
              v-for="c in categoryList"
              :key="c.id"
              :class="{ active: form.category_id === c.id }"
              @click="selectCategory(c)">
              {{ c.name }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label">反馈标题<span class="required">*</span> <span class="form-hint">(2-100字)</span></div>
          <input v-model="form.title" class="form-input" maxlength="100" placeholder="请简要概括您的问题或建议">
        </div>

        <div class="form-item">
          <div class="form-label">反馈内容 <span class="form-hint">(您提我改)</span><span class="required">*</span></div>
          <textarea class="form-textarea" v-model="form.content" placeholder="您的任何意见对我们都很重要，凡是有价值意见都将被采纳，一旦采纳将视重要程度给予不同现金奖励，欢迎您畅所欲言！" maxlength="1000"></textarea>
          <div class="char-count">{{ form.content.length }}/1000</div>
        </div>

        <div class="form-item">
          <div class="form-label">联系方式</div>
          <input v-model="form.contact" class="form-input" maxlength="100" placeholder="手机号/邮箱（选填，方便我们联系您奖励）">
        </div>

        <div class="form-item">
          <div class="form-label">有图有真相 <span class="form-hint">(更容易被采纳)</span></div>
          <div class="upload-area">
            <div v-for="(img, i) in uploadedImages" :key="i" class="upload-item">
              <img :src="baseURL + img" class="upload-preview" />
              <van-icon name="clear" size="16" color="#fff" class="upload-delete" @click="removeUpload(i)"/>
            </div>
            <div v-if="uploadedImages.length < 6" class="upload-btn" @click="$refs.fileInput.click()">
              <van-icon name="plus" size="24" color="#666" />
            </div>
          </div>
          <input ref="fileInput" type="file" accept="image/*" multiple style="display:none" @change="handleFileUpload" />
          <p class="upload-tip">支持图片上传，图片大小不得超过10MB，最多6张</p>
        </div>

        <div class="form-item reward-rules">
          <div class="form-label">奖励规则</div>
          <p>我们已经设置巨额奖金，专门收集反馈意见，以便我们优化系统和功能，给您带来更好的体验！一旦被采纳，将根据重要程度给予奖励（未采纳除外）。</p>
        </div>

        <div class="submit-btn" :class="{disabled: submitting}" @click="submitFeedback">
          {{ submitting ? '提交中...' : '提交反馈' }}
        </div>
      </div>

      <!-- ② 我的反馈 -->
      <div v-else class="my-feedback">
        <div class="filter-bar">
          <div
            v-for="(s, idx) in statusOptions"
            :key="s.value"
            class="filter-chip"
            :class="{ active: statusFilter === s.value }"
            @click="statusFilter = s.value; loadMyList(true)">
            {{ s.label }}
          </div>
        </div>

        <div v-if="loadingList" class="loading-tip">加载中...</div>
        <div v-else class="feedback-list">
          <div v-for="item in myList" :key="item.id" class="fb-item" @click="openDetail(item)">
            <div class="fb-head">
              <div class="fb-category">[{{ item.category_name || '未分类' }}]</div>
              <div
                class="fb-status"
                :class="'s' + item.status">
                {{ statusText(item.status) }}
              </div>
            </div>
            <div class="fb-title">{{ item.title }}</div>
            <div class="fb-content">{{ item.content }}</div>
            <div class="fb-footer">
              <span class="fb-time">{{ item.created_at }}</span>
              <span v-if="item.has_reply" class="fb-reply-tag">
                <van-icon name="comment-o" size="12"/> 已回复
              </span>
            </div>
          </div>
          <div v-if="myList.length === 0" class="empty-state">
            <img src="/static/image/img_none_sj.avif" alt="" class="empty-img" />
            <p>暂无反馈记录</p>
          </div>
          <div v-if="total > myList.length" class="load-more-wrap">
            <div class="load-more-btn" @click="loadMore">加载更多</div>
          </div>
        </div>
      </div>
    </template>

    <!-- 详情弹框 -->
    <van-popup v-model="showDetail" round position="bottom" :style="{ height: '80%', background: '#1a1a1a' }" closeable>
      <div class="fb-detail" v-if="detail.id">
        <div class="d-head">
          <div class="d-title">{{ detail.title }}</div>
          <div class="d-status" :class="'s' + detail.status">{{ statusText(detail.status) }}</div>
        </div>
        <div class="d-meta">
          <span>分类：{{ detail.category_name }}</span>
          <span>提交时间：{{ detail.created_at }}</span>
          <span v-if="detail.replied_at">回复时间：{{ detail.replied_at }}</span>
        </div>
        <div v-if="detail.contact" class="d-contact">联系方式：{{ detail.contact }}</div>

        <div class="d-block">
          <div class="d-label">反馈内容</div>
          <div class="d-content">{{ detail.content }}</div>
          <div v-if="detail.images && detail.images.length" class="d-images">
            <img v-for="(src, i) in detail.images" :key="i" :src="src" class="d-image" @click="previewImg(src)">
          </div>
        </div>

        <div class="d-block reply-block">
          <div class="d-label">
            <van-icon name="comment-o" size="14" color="#DFB372"/>
            &nbsp;客服回复
          </div>
          <div v-if="detail.reply_content" class="d-reply">{{ detail.reply_content }}</div>
          <div v-else class="d-reply empty-reply">暂未回复，敬请耐心等待...</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'noticeFankui',
  data() {
    return {
      activeFankuiTab: 0,
      showCategoryPicker: false,
      categoryList: [],
      form: {
        category_id: 0,
        title: '',
        content: '',
        contact: '',
      },
      uploadedImages: [],
      submitting: false,
      statusOptions: [
        { label: '全部', value: '' },
        { label: '待处理', value: 0 },
        { label: '处理中', value: 1 },
        { label: '已回复', value: 2 },
        { label: '已关闭', value: 3 },
      ],
      statusFilter: '',
      loadingList: false,
      myList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      showDetail: false,
      detail: {},
    }
  },
  computed: {
    isLogin() {
      return !!(this.$store && this.$store.state && this.$store.state.token);
    },
    categoryName() {
      if (!this.form.category_id) return '';
      const c = this.categoryList.find(c => c.id === this.form.category_id);
      return c ? c.name : '';
    },
    baseURL() {
      return sessionStorage.getItem('baseURL') || '';
    }
  },
  created() {
    if (!this.isLogin) return;
    this.loadCategories();
  },
  methods: {
    openLogin(type = 1) {
      let p = this.$parent;
      let depth = 0;
      while (p && depth < 10) {
        if (typeof p.loginNewShow !== 'undefined') {
          p.loginDefaultType = type;
          p.loginNewShow = true;
          return;
        }
        p = p.$parent;
        depth++;
      }
      if (this.$root && typeof this.$root.loginNewShow !== 'undefined') {
        this.$root.loginDefaultType = type;
        this.$root.loginNewShow = true;
      }
    },
    statusText(s) {
      s = Number(s);
      const map = { 0: '待处理', 1: '处理中', 2: '已回复', 3: '已关闭' };
      return map[s] || '未知';
    },
    toast(msg, type = 'fail') {
      this.$toast && this.$toast({ message: msg, type });
    },
    loadCategories() {
      this.$apiFun.post('/api/feedbackcategories', {}).then(res => {
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.categoryList = res.data;
        }
      });
    },
    selectCategory(c) {
      this.form.category_id = c.id;
      this.showCategoryPicker = false;
    },
    handleFileUpload(e) {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;
      const remain = 6 - this.uploadedImages.length;
      const toUpload = files.slice(0, remain);
      if (toUpload.length < files.length) {
        this.$toast('最多上传6张图片');
      }
      toUpload.forEach(file => {
        if (file.size > 10 * 1024 * 1024) {
          this.$toast('图片大小不能超过10MB');
          return;
        }
        const formdata = new FormData();
        formdata.append('file', file);
        this.$apiFun.post('/api/feedback/upload', formdata).then(res => {
          if (res && res.code === 200 && res.data) {
            this.uploadedImages.push(res.data);
          } else {
            this.$toast((res && res.message) || '上传失败');
          }
        }).catch(() => { this.$toast('上传失败'); });
      });
      e.target.value = '';
    },
    removeUpload(i) {
      this.uploadedImages.splice(i, 1);
    },
    submitFeedback() {
      if (this.submitting) return;
      if (!this.form.category_id) return this.toast('请选择分类');
      if (!this.form.title.trim() || this.form.title.trim().length < 2) return this.toast('标题不少于2个字');
      if (!this.form.content.trim() || this.form.content.trim().length < 5) return this.toast('内容不少于5个字');
      this.submitting = true;
      const images = this.uploadedImages.slice();
      this.$apiFun.post('/api/feedback/submit', {
        category_id: this.form.category_id,
        title: this.form.title.trim(),
        content: this.form.content.trim(),
        contact: (this.form.contact || '').trim(),
        images,
      }).then(res => {
        this.submitting = false;
        if (res && res.code === 200) {
          this.$toast && this.$toast.success('提交成功！请在「我的反馈」中查看进展');
          this.form = { category_id: 0, title: '', content: '', contact: '' };
          this.uploadedImages = [];
        } else {
          this.toast((res && res.message) || '提交失败');
        }
      }).catch(() => { this.submitting = false; this.toast('网络错误'); });
    },
    loadMyList(reset = false) {
      if (this.loadingList) return;
      if (reset) { this.page = 1; this.myList = []; this.total = 0; }
      this.loadingList = true;
      this.$apiFun.post('/api/feedbacklist', {
        page: this.page,
        pageSize: this.pageSize,
        status: this.statusFilter,
      }).then(res => {
        this.loadingList = false;
        if (res && res.code === 200) {
          const d = res.data || {};
          const list = Array.isArray(d.list) ? d.list : [];
          if (reset) this.myList = list;
          else this.myList = this.myList.concat(list);
          this.total = Number(d.total) || 0;
        }
      }).catch(() => { this.loadingList = false; });
    },
    loadMore() {
      if (this.loadingList) return;
      if (this.myList.length >= this.total) return;
      this.page++;
      this.loadMyList(false);
    },
    openDetail(item) {
      this.detail = Object.assign({
        id: 0, category_name: '', title: '', content: '',
        images: [], contact: '', status: 0, reply_content: '',
        created_at: '', replied_at: '',
      }, item);
      this.showDetail = true;
      // 再拉一次取完整 reply
      this.$apiFun.post('/api/feedbackdetail', { id: item.id }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.detail = Object.assign({}, this.detail, res.data);
        }
      });
    },
    previewImg(src) {
      if (!src) return;
      const images = (this.detail && this.detail.images) || [];
      const index = Math.max(0, images.indexOf(src));
      ImagePreview({
        images: images.length ? images : [src],
        startPosition: index,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.fankui-page {
  padding: 0.3rem;
  color: #fff;
  min-height: 80vh;
}
.not-login-tip {
  text-align: center;
  padding: 2.5rem 0 1rem;
  .empty-img { width: 2rem; height: 2rem; opacity: 0.55; }
  .t1 { color: #888; margin: 0.4rem 0 0.6rem; font-size: 0.3rem; }
  .btns {
    display: flex; justify-content: center; gap: 0.3rem;
    .btn-login, .btn-register {
      padding: 0.18rem 0.55rem;
      border-radius: 0.3rem;
      font-size: 0.3rem;
    }
    .btn-login { background: #DFB372; color: #1E1F24; }
    .btn-register { background: transparent; color: #DFB372; border: 1px solid #DFB372; }
  }
}
.fankui-tabs {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.3rem;
  .fankui-tab {
    padding: 0.15rem 0.4rem;
    border-radius: 0.3rem;
    font-size: 0.3rem;
    background: #292A2C;
    color: #999;
    &.active { background: #DFB372; color: #1E1F24; }
  }
}
.fankui-form {
  .form-item {
    margin-bottom: 0.4rem;
    position: relative;
    .form-label {
      font-size: 0.3rem;
      margin-bottom: 0.2rem;
      display: flex; align-items: center;
      .required { color: #ff4d4f; margin-left: 0.05rem; }
      .form-hint {
        font-size: 0.26rem; color: #888;
        font-weight: normal; margin-left: 0.08rem;
      }
    }
    .form-input {
      width: 100%;
      padding: 0.25rem 0.3rem;
      background: #292A2C;
      border: none;
      border-radius: 0.15rem;
      color: #fff;
      font-size: 0.3rem;
      box-sizing: border-box;
      outline: none;
      &::placeholder { color: #666; font-size: 0.28rem; }
    }
    .form-select {
      display: flex; align-items: center; justify-content: space-between;
      padding: 0.25rem 0.3rem;
      background: #292A2C;
      border-radius: 0.15rem;
      font-size: 0.3rem;
      .placeholder { color: #666; }
    }
    .type-dropdown {
      background: #292A2C;
      border-radius: 0.15rem;
      margin-top: 0.08rem;
      position: relative;
      z-index: 10;
      max-height: 6rem;
      overflow-y: auto;
      .type-option {
        padding: 0.3rem;
        font-size: 0.3rem;
        color: #aaa;
        border-bottom: 1px solid #3B3C3D;
        &.active { color: #DFB372; }
        &:last-child { border-bottom: none; }
      }
    }
    .form-textarea {
      width: 100%;
      min-height: 3rem;
      padding: 0.25rem;
      background: #292A2C;
      border: none;
      border-radius: 0.2rem;
      color: #fff;
      font-size: 0.3rem;
      box-sizing: border-box;
      outline: none;
      resize: vertical;
      &::placeholder { color: #666; }
    }
    .char-count {
      text-align: right;
      font-size: 0.22rem;
      color: #666;
      margin-top: 0.1rem;
    }
    .upload-area {
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem;
      .upload-item {
        position: relative;
        width: 2rem;
        height: 2rem;
        .upload-preview {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 0.1rem;
        }
        .upload-delete {
          position: absolute;
          top: -0.1rem;
          right: -0.1rem;
          background: rgba(0,0,0,.6);
          border-radius: 50%;
          padding: 0.04rem;
        }
      }
      .upload-btn {
        width: 2rem;
        height: 2rem;
        background: #292A2C;
        border-radius: 0.1rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .upload-tip {
      font-size: 0.26rem;
      color: #666;
      margin-top: 0.2rem;
      line-height: 1.5;
    }
  }
  .reward-rules {
    p {
      font-size: 0.28rem;
      color: #999;
      line-height: 1.7;
      margin: 0;
      padding: 0.25rem;
      background: #292A2C;
      border-radius: 0.15rem;
    }
  }
  .submit-btn {
    width: 94%;
    padding: 0.3rem;
    background: #DFB372;
    color: #1E1F24;
    text-align: center;
    border-radius: 0.3rem;
    font-size: 0.32rem;
    margin: 0.5rem auto 0;
    &.disabled { opacity: 0.6; pointer-events: none; }
  }
}
.my-feedback {
  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 0.15rem;
    margin-bottom: 0.3rem;
    .filter-chip {
      padding: 0.12rem 0.28rem;
      border-radius: 0.3rem;
      background: #292A2C;
      font-size: 0.26rem;
      color: #999;
      &.active { background: #DFB372; color: #1E1F24; }
    }
  }
  .loading-tip { text-align: center; padding: 1rem; color: #888; font-size: 0.28rem; }
  .feedback-list {
    .fb-item {
      background: #292A2C;
      border-radius: 0.2rem;
      padding: 0.3rem;
      margin-bottom: 0.25rem;
      .fb-head {
        display: flex; justify-content: space-between; align-items: center;
        margin-bottom: 0.15rem;
        .fb-category { color: #DFB372; font-size: 0.26rem; }
        .fb-status {
          font-size: 0.24rem;
          padding: 0.04rem 0.16rem;
          border-radius: 0.2rem;
          &.s0 { background: rgba(255,193,7,.18); color: #ffc107; }
          &.s1 { background: rgba(64,158,255,.18); color: #409eff; }
          &.s2 { background: rgba(82,196,26,.18); color: #52c41a; }
          &.s3 { background: rgba(144,147,153,.18); color: #8c8c8c; }
        }
      }
      .fb-title {
        font-size: 0.32rem;
        margin-bottom: 0.12rem;
        color: #fff;
        line-height: 1.5;
      }
      .fb-content {
        font-size: 0.28rem;
        color: #bbb;
        line-height: 1.55;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .fb-footer {
        margin-top: 0.2rem;
        display: flex; justify-content: space-between; align-items: center;
        .fb-time { color: #777; font-size: 0.24rem; }
        .fb-reply-tag {
          color: #52c41a;
          font-size: 0.24rem;
          display: inline-flex; align-items: center; gap: 0.05rem;
        }
      }
    }
    .empty-state {
      text-align: center;
      padding: 2rem 0;
      .empty-img { width: 2.4rem; height: 2.4rem; opacity: 0.55; }
      p { color: #666; font-size: 0.3rem; margin-top: 0.3rem; }
    }
    .load-more-wrap {
      padding: 0.2rem 0 0.4rem;
      .load-more-btn {
        text-align: center;
        padding: 0.22rem;
        background: #292A2C;
        border-radius: 0.3rem;
        color: #DFB372;
        font-size: 0.28rem;
      }
    }
  }
}
.fb-detail {
  padding: 0.35rem 0.35rem 0.5rem;
  color: #fff;
  max-height: 78vh;
  overflow-y: auto;
  .d-head {
    display: flex; flex-direction: column;
    margin-bottom: 0.25rem;
    gap: 0.2rem;
    .d-title {
      font-size: 0.36rem;
      line-height: 1.5;
    }
    .d-status {
      align-self: flex-start;
      font-size: 0.24rem;
      padding: 0.05rem 0.18rem;
      border-radius: 0.2rem;
      &.s0 { background: rgba(255,193,7,.18); color: #ffc107; }
      &.s1 { background: rgba(64,158,255,.18); color: #409eff; }
      &.s2 { background: rgba(82,196,26,.18); color: #52c41a; }
      &.s3 { background: rgba(144,147,153,.18); color: #8c8c8c; }
    }
  }
  .d-meta {
    font-size: 0.24rem;
    color: #888;
    line-height: 1.8;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.18rem;
  }
  .d-contact {
    font-size: 0.26rem;
    color: #bbb;
    margin-bottom: 0.25rem;
  }
  .d-block {
    margin-top: 0.35rem;
    padding-top: 0.3rem;
    border-top: 1px solid #2b2b2b;
    &:first-of-type { border-top: 1px solid #2b2b2b; }
    .d-label {
      font-size: 0.3rem;
      color: #DFB372;
      margin-bottom: 0.2rem;
      display: inline-flex; align-items: center;
    }
    .d-content {
      font-size: 0.3rem;
      line-height: 1.7;
      color: #ddd;
      white-space: pre-wrap;
    }
    .d-images {
      display: flex; flex-wrap: wrap;
      gap: 0.15rem;
      margin-top: 0.2rem;
      .d-image {
        width: 2.1rem;
        height: 2.1rem;
        object-fit: cover;
        border-radius: 0.15rem;
      }
    }
    .d-reply {
      font-size: 0.3rem;
      line-height: 1.75;
      padding: 0.3rem;
      background: #292A2C;
      border-radius: 0.15rem;
      color: #f5f5f5;
      white-space: pre-wrap;
      &.empty-reply {
        color: #666;
        background: transparent;
        padding: 0;
        font-size: 0.28rem;
      }
    }
    .reply-block .d-label {
      color: #52c41a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/notice/fankui.vue